/**
 * Biometric Authentication Service
 * Stub implementation for web-only builds (Capacitor removed)
 * Native biometric auth is handled by native apps directly
 */

export interface BiometricAuthResult {
  success: boolean;
  error?: string;
  credentials?: {
    username: string;
    password?: string;
  };
}

class BiometricService {
  private readonly SERVER_ID = 'oilwellx.com';

  /**
   * Check if biometric authentication is available
   * Always returns false for web builds
   */
  async isAvailable(): Promise<boolean> {
    return false;
  }

  /**
   * Check if we have a local credential flag for this user
   */
  hasCredential(_userId: string): boolean {
    return false;
  }

  /**
   * Register/Save credentials securely using Biometrics
   * No-op for web builds
   */
  async register(_email: string, _password?: string): Promise<BiometricAuthResult> {
    console.warn('Biometric auth not available in web build');
    return { success: false, error: 'Not available in web build' };
  }

  /**
   * Authenticate and retrieve credentials
   * No-op for web builds
   */
  async authenticate(): Promise<BiometricAuthResult> {
    return {
      success: false,
      error: 'Biometric auth not available in web build'
    };
  }

  /**
   * Clear stored credentials
   */
  async removeCredential(): Promise<void> {
    // No-op
  }
}

export const biometricService = new BiometricService();
